module.exports = __webpack_public_path__ + "img/icon-vk-acc-dell.4f65b2ae.svg";